import { useQuery, useReactiveVar } from '@apollo/client';
import { Button, Typography } from '@mui/material';
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import type React from 'react';
import { useEffect } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import styles from 'src/Administration/AdministrationStyles';
import Drawer from 'src/Administration/Drawer/Drawer';
import TopNavBar from 'src/Administration/TopNavbar/TopNavbar';
import staffStatus from 'src/api/admin/staffStatus';
import { HOME_PATH } from 'src/constants';
import viewStateVar from 'src/store/viewState';
import { requireAuth } from 'src/utils/authGuard';

interface StaffStatusData {
  me: {
    role: string;
  };
}

function SystemAdminLayout(): React.ReactElement | null {
  const classes = styles();
  const viewState = useReactiveVar(viewStateVar);
  const navigate = useNavigate();
  const { data: staffStatusData } = useQuery<StaffStatusData>(staffStatus, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    viewStateVar({
      ...viewStateVar(),
      signedInUserRole: staffStatusData?.me.role ?? '',
    });
  }, [staffStatusData]);

  const goHomeHandler = (): void => {
    navigate({ to: HOME_PATH });
  };

  if (viewState.signedInUserRole === 'ADM' || viewState.signedInUserRole === 'MGR')
    return (
      <div className={classes.administrationPage}>
        <DndProvider backend={HTML5Backend}>
          <TopNavBar />
          <div className={classes.drawerAndContentWrapper}>
            <div style={{ width: '250px' }}>
              <Drawer />
            </div>
            <div
              style={{
                flexGrow: '1',
              }}
            >
              <Outlet />
            </div>
          </div>
        </DndProvider>
      </div>
    );
  else if (viewState.signedInUserRole === 'USR') {
    return (
      <div className={classes.accessDeny}>
        <Typography className={classes.accessDenyText}>You do not have permission to access system admin</Typography>
        <Button variant="contained" color="primary" className={classes.goHomeButton} onClick={goHomeHandler}>
          Back to Library Page
        </Button>
      </div>
    );
  }

  return null;
}

export const Route = createFileRoute('/systemadmin/_layout')({
  beforeLoad: () => {
    requireAuth();
  },
  component: SystemAdminLayout,
});
